// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6e261aed","386":"6e404ada","411":"3d2a8d6d","462":"13b25757","765":"abda694f"}[chunkId] + ".chunk.js";
};